export default {"src":"/_next/static/media/protection_shield.97ee75d2.svg","height":83,"width":83,"blurWidth":0,"blurHeight":0};